import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { InteractionsListComponent } from './interactions-list.component';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { TelephonyComponentsModule } from '../../../telephony-components.module';

const routes: Routes = [
  { path: '', component: InteractionsListComponent, data: { title: 'Interactions' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InteractionsListRoutingModule {}

@NgModule({
  imports: [
    InteractionsListRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TelephonyComponentsModule,
  ],
  declarations: [InteractionsListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InteractionsListModule {}
